import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/environment';
import { handleIntegrations } from './app/shared/util/integrations';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
  handleIntegrations();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
